export interface IBillingHistory {
  planTitle?: string;
  type: string;
  date: string;
  payMethod: string;
  price: number;
  billingStatus: string;
  status: string;
  invoice: string;
  volume: string;
  remainder: string;
}
